// 注册一个全局自定义指令 `v-drag`
export default {
  bind: function(el) {
    if (el.dataset.draggable === 'false') { return }
    el.onmousedown = function(e) {
      let parentBox = e.currentTarget.parentElement.parentElement;
      let disx = e.pageX - el.offsetLeft;
      let disy = e.pageY - el.offsetTop;
      parentBox.onmousemove = function(e) {
        el.style.left = e.pageX - disx + 'px';
        el.style.top = e.pageY - disy + 'px';
      };
      parentBox.onmouseleave = function(e) {
        parentBox.onmousemove = null;
        parentBox.onmouseup = null;
      };
      parentBox.onmouseup = function(e) {
        parentBox.onmousemove = null;
        parentBox.onmouseup = null;
      };
      e.preventDefault();
    };
  }
};
